import { Modal, Form, Input, App } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useClientUpdateQuery, useUpdateSaveClientMutation } from '../../store/ReactWebSiteApi';
import GetClientType from './GetClientType';

function ClientEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const editForm = useRef()
    const {data,isSuccess} = useClientUpdateQuery({ec_id:props.ec_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);
                editForm.current.setFieldsValue({
                    ec_type_id:[data.Result.ec_type_id],
                    ec_name:data.Result.ec_name,
                    ec_content:data.Result.ec_content,
                })
                setInfo(prevState=>({...prevState,
                    ec_type_id:data.Result.ec_type_id,
                    ec_name:data.Result.ec_name,
                    ec_content:data.Result.ec_content,              
                }))
            }
        }
    },[data,isSuccess])
    const getClientTypeEdit =  (e) => {setInfo(prevState=>({...prevState,ec_type_id:e}))}
    const [submitUpdateSave] = useUpdateSaveClientMutation()
    return (
        <>
            {props.ec_state==='2'&&                      
                        <a onClick={() => {
                            setOpen(true)
                        }}>修改</a>}
            <Modal
                open={open}
                title='修改客户'
                okText="提交"
                cancelText="取消"
                width={600}
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    submitUpdateSave({
                        ec_name:info.ec_name,
                        ec_update_uid:localStorage.getItem('eu_id'),
                        ec_update_uname:localStorage.getItem('eu_name'),
                        ec_content:info.ec_content,
                        ec_id:props.ec_id,
                        ec_e_id:localStorage.getItem('e_id'),
                        ec_type_id:info.ec_type_id,
                        ec_esv_id:'9',
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >
                    <GetClientType
                        required 
                        name="ec_type_id" 
                        label='客户类型' 
                        getClientType={getClientTypeEdit}
                        style={{width:"200px"}}
                    />
                    <Form.Item name="ec_name" label='客户名称' wrapperCol={{span:15}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,ec_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="ec_content" label='客户备注' wrapperCol={{span:15}}>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,ec_content:e.target.value}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientEdit